import { defineStyleConfig } from "@chakra-ui/react";

export const Radio = defineStyleConfig({
  defaultProps: {},
  variants: {
    primary: {
      color: 'yellow',
      bgColor: 'red',
      control: {
        _checked: {
          color: '#01ad6e',
          bgColor: 'white',
          borderColor: '#01ad6e',
          borderWidth: '2px',

          _hover: {
            bgColor: 'white',
            borderColor: '#01ad6e',
          }
        },
      },
    },
  },
});